<template lang="pug">
transition(
  appear
  v-on:enter="welcome"
)
  a-entity.destinations(:class="{'untouchable': loading.start}")

    template(v-if="welcomed")
      dest-slides(v-if="!loading.start" @touchStart="onSlideTouchDown" @touchEnd="onSlideTouchEnd")
      .shadow
      //logo(:modeSwitchable="false")
      button-menu(:disable="loading.start")

      .bottom-section
        map-indi
        .button-container
          button-go(@go="loadScene" v-if="!loading.start")


        //img.loading(src="~assets/ui/loading.png" v-if="loading.start")
      //menus(v-if="showMenu")
      //gallery(v-if="showGallery")
      //qr-page(v-if="showQRPage")
      //pattern-trans(v-if="1")
      goo-pagination
      //pattern-trans(v-if="loading.start")
      scene-cta(v-if="showCta" @complete="ctaComplete")


</template>
<script>

import * as PATHS from 'src/router/paths'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3, Power2, Elastic} from 'gsap'
//import Component from '@/components/Component'

//import assets from './assets'

import Logo from 'src/components/vca/widgets/Logo'
import ButtonMenu from 'src/components/vca/widgets/ButtonMenu'
import ButtonShare from 'src/components/vca/widgets/ButtonShare'
import ButtonGo  from 'src/components/vca/widgets/ButtonGo'

import MapIndi from 'src/components/vca/widgets/Map'

import DestSlides from './DestSlides2'
import Menus from 'src/components/vca/menu/Menu'
import Gallery from 'src/components/vca/gallery/Gallery'
import QRPage from 'src/components/vca/widgets/old/QRPage'
import * as MODES from 'src/config/modes'
import PatternTrans from 'src/components/vca/widgets/PatternTrans'
import GooPagination from 'src/components/vca/widgets/GooPagination2'
import AnalyticsService from '@/services/AnalyticsService'
import SceneCta from "../widgets/SceneCta";


export default {
  name: "Destinations",
  props: {
    // id: {
    //   required: true
    // }
  },
  components: {
    SceneCta,
    PatternTrans,
    Logo,
    ButtonMenu,
    ButtonShare,
    ButtonGo,
    DestSlides,
    Menus,
    Gallery,
    'qr-page':QRPage,
    MapIndi,
    GooPagination,

  },
  data() {
    return {
      MODES,
      //assets: assets,
      sceneSelected: false,
      progress: {
        assets: 0,
        media: 0,
        sounds: 0,
      },
      startTime: Date.now(),
      updateTime: 1000 / 30,
      minTime: 5000,

      loading: {
        progress: 0,
        completed: false,
        start: false
      },
      loadingTl: 1,
      welcomed: false,
      currIdx: 0,
      transbgm: null,
      showCta: false
    }
  },
  computed:{
    ...mapState('app', ['mode', 'showDestInfo', 'showMenu', 'showGallery', 'showQRPage', 'loadSceneProgress', 'currSceneIdx'])
    
  },
  methods: {
    ...mapMutations('app', ['toggleDestInfo', 'addToGallery', 'setLoadScene', 'setCamZoom', 'setCamDistort', 'playBgm']),
    init() {},
    animate() {},
    // sceneChange(idx){
    //   this.currIdx = idx
    // },
    toScene(){
      //console.log('yyyyyyy', id)
      this.$router.replace({
        name: PATHS.SCENES,
        params: {
          id: this.currSceneIdx,
        },
      })
    },

    loadScene(){
      AnalyticsService.sendEvent('destination', 'click', `button-start-${this.currSceneIdx}`)
      //console.log(909090, id)
      //this.idx = id
      //console.log(3030303030303, SoundService)
      window.AudioPlayer.playTransBgm()

      let cb = () => {
        this.enter()
        //this.listen()
        //this.load()

      }
      this.loadingAni(cb)
      this.sceneSelected = true
      this.loading.start = true

    },
    onSlideTouchDown(){
      let tl = new TimelineMax({
        onComplete: () =>{

        },
      })
      this.tl = tl
      tl.add('start')
        .to(
          this,
          0.2,
          {
            loadingTl: 1.5,
            ease: Power2.easeOut,
          },
          `start+=0`
        )
    },
    onSlideTouchEnd(){
      let tl = new TimelineMax({
        onComplete: () =>{
        },
      })
      this.tl = tl
      tl.add('start')
        .to(
          this,
          0.2,
          {
            loadingTl: 1,
            ease: Power2.easeOut,
          },
          `start+=0`
        )
    },
    ctaComplete(){
      this.showCta = false
      let tl = new TimelineMax({
        onComplete: () =>{
          this.enter()
        },
      })
      this.tl = tl
      tl.add('start')
        // .set(
        //   this,
        //   {
        //     loadingTl: 4,
        //   },
        //   `start+=0`
        // )
        .to(
          this,
          1,
          {
            loadingTl: 1,
            ease: Elastic.easeOut.config(2, 0.5),
          },
          `start+=0`
        )
    },
    loadingAni(cb){
      window.Map.zoomIn()
      let tl = new TimelineMax({
        onComplete: () =>{
          //this.showCta = true
          //cb()
        },
      })
      this.tl = tl
      tl.add('start')
        .to(
          this,
          4,
          {
            loadingTl: 3,
            ease: Power2.easeOut,
          },
          `start+=0`
        )
        .set(
          this,
          {
            showCta: true,
          },
          `start+=1`
        )
        // .to(
        //   this,
        //   2,
        //   {
        //     loadingTl: 6,
        //     ease: Linear.easeNone,
        //   },
        //   `start+=1`
        // )
        // .to(
        //   this,
        //   0.4,
        //   {
        //     loadingTl: 1,
        //     ease: Elastic.easeOut.config(1.2, 0.4),
        //   },
        //   `start+=1`
        // )
    },
    // loadedAni(cb){
    //   let tl = new TimelineMax({ onComplete: () => {
    //       cb()
    //     } })
    //   this.tl = tl
    //   tl.add('start')
    //     .to(
    //       this,
    //       0.1,
    //       {
    //         loadingTl: 0,
    //         ease: Elastic.easeOut.config(1.5, 0.5),
    //       },
    //       `start+=0`
    //     )
    // },

    listen() {
      this.interval = setInterval(this.update, this.updateTime)
    },
    unlisten() {
      clearInterval(this.interval)
    },
    async load() {
      this.startTime = Date.now()
      //SoundService.load(soundManifest)
      //console.log('load!!!!!', SoundService)
      //this.setLoadScene(true)
    },
    update() {
      //this.setCamZoom(this.loadingTl*0.5)

      this.progress.assets = this.loadSceneProgress
      //this.progress.sounds = SoundService.progress

      // this.progress.assets = 0
      // if (!this.loadAframe) {
      //   this.progress.assets = document.querySelector('a-assets').__vue__.showProgress
      // }
      let actualProgress = 0
      actualProgress += this.progress.assets * 1
      //actualProgress += this.progress.sounds * 1


      let maxProgress = (Date.now() - this.startTime) / this.minTime
      maxProgress = Math.min(maxProgress, 1)

      let showProgress = Math.min(actualProgress, maxProgress)
      showProgress = Math.min(showProgress, 1)

      this.loading.progress = showProgress
      //console.log(9999, this.loadSceneProgress, this.loading.progress, this.progress.assets)
      if (this.loading.progress >= 1) {
        this.enter()
      }
    },
    enter() {
      //console.log(777, AssetService)
      this.unlisten()
      //this.show = true
      //console.log(9999, this.loading.progress)
      //this.toScene(this.currIdx)
      let cb = () => {
        this.loading.start = false
        this.toScene()
      }
      cb()
      //this.loadedAni(cb)


    },
    welcome(el, done){
      //this.animateIn(done)
      console.log('welcome!!!!!!')
      //console.log(this.welcomed)
      let cb = () => {
        this.welcomed = true
        //window.GyroView.animeIn()
        window.MapTitle.animeIntro(0)
        window.Logo.showLogo()
        done()
      }
      window.App.welcomeAni(cb)
    },

  },
  mounted() {
    this.init()
    this.animate()
    AnalyticsService.sendPageview(`/destinations`)

    //this.playBgm()

  },
  beforeDestroy(){

  },
  watch: {
    loadingTl(val){
      this.setCamZoom(val)
    }
  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .destinations
    +full()


    //img
      +full()
      object-fit: cover
      display: block

    .logo
      z-index: 800
    .frame
      //z-index: 99
    .button-menu
      z-index: 110
    .menu
      z-index: 900
    .map
      z-index: 110
    .dest-slides
      z-index: 100
    .scene-cta
      z-index: 999
    .shadow
      pointer-events: none
      +full()
      z-index: 101
      background: linear-gradient(180deg, rgba(26, 26, 26, 0.2), rgba(26, 26, 26, 0) 20%)
    .goo-pagination
      z-index: 120
    .qr-page
      z-index: 200
    .gallery
      z-index: 200



    .btn
      z-index: 110
      pointer-events: all
      position: absolute
      bottom: 0
      img
        position: relative
        width: 100%
        height: auto
        object-fit: cover
        display: block
      .bag
        //position: relative
        //object-fit: cover
        //display: block
    .btn-gallery
      left: 0

    .btn-camera
      //background: red
      right: 0
      //width: 8rem

    .bottom-section
      pointer-events: none
      z-index: 110
      width: 100%
      bottom: 1rem
      position: absolute
      left: 0
      //background: #ffd81b
      display: flex
      justify-content: center
      align-items: center
      flex-direction: column
      .button-container
        position: relative
        //background: #3a602e
        width: 1.8rem
        height: 0.5rem
        .button-go
          //width: 90%
          margin: 0.1rem auto 0 auto
          //background: #3a54a2
          pointer-events: all
          white-space: nowrap

        //.loading
          display: block
          margin-top: 0.1rem
          line-height: 0
          width: 1rem
        .loading
          transform-origin: center
          position: absolute
          top: 0
          left: 0
          margin-top: 0.1rem
          //line-height: 0
          //background: greenyellow
          pointer-events: all
          border: rgba(255, 255, 255, 0) 2px solid
          border-radius: 0.38rem
          padding: 0.08rem 0.5rem
          white-space: nowrap
          //position: absolute
          //bottom: $ui-margin-top + 0.05rem
          //left: $ui-margin-left + 0.15rem
          display: flex
          align-items: center
          justify-content: center
          span
            margin: 0
            padding: 0
            color: white
            line-height: 0.16rem
            font-size: 0.16rem

  .popdown-enter-active
    transition: all 0.7s cubic-bezier(0.215, 0.61, 0.355, 1) 0.5s
  .popdown-enter
    transform: translateY(-100%) scale(1.5)
    opacity: 0


</style>